<template>
  <div class="person-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Profissionais &raquo; Cartão digital</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col cols="12" class="mt-n3">
            <a class="cj-label" @click="goBack" href="#"><i class="fa fa-long-arrow-left mr-1"></i>Voltar</a>
          </b-col>
        </b-row>
        <validation-observer ref="personForm" v-slot="{ invalid }">
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Cartão digital - {{personForm.name}}</p>

                    <div>
                      <a :href="digitalCardUrl + personForm.professional_profile.slug" v-if="personForm.professional_profile.enabled && personForm.professional_profile.id != null" target="_blank" class="mr-3"><i class="far fa-link"></i></a>
                      <div class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="personForm.professional_profile.enabled" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" />
                        <div class="state p-success">
                          <label></label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content">
                  <b-row>
                    <b-col cols="12" md="8">
                      <b-row>
                        <div class="photo-container">
                          <div id="personPhoto" class="person-photo rounded" title="Foto" @click="$refs.fileInput.$el.childNodes[0].click()"></div>
                          <b-button class="delete-photo" size="sm" variant="danger" v-if="((personForm.id == null && canAdd) || (personForm.id != null && canEdit)) && (currentPhoto || photoFile || personForm.photo)" @click="removePhoto"><i class="far fa-trash-alt"></i></b-button>
                          <label class="cj-label d-block">Selecionar foto</label>
                          <b-form-file class="d-block" style="width: 1px; height: 1px;opacity: 0" v-model="photoFile" accept=".jpg, .png" placeholder="" ref="fileInput" @input="photoChanged" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))"></b-form-file>
                        </div>
                        <b-col>
                          <label class="cj-label">Link para divulgação</label>
                          <validation-provider name="link para divulgação" :rules="{ required: true, slug: true }" v-slot="{ errors }">
                            <b-input-group :prepend="digitalCardUrl">
                              <b-form-input type="text" v-model="personForm.professional_profile.slug" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }"></b-form-input>
                            </b-input-group>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row class="mb-3">
                        <b-col>
                          <label class="cj-label">Cor primária</label>
                          <b-form-input type="color" v-model="personForm.professional_profile.primary_color" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))"></b-form-input>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Cor secundária</label>
                          <b-form-input type="color" v-model="personForm.professional_profile.secondary_color" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))"></b-form-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-row>
                            <div class="photo-container">
                              <div id="professionalProfileBackgroundImage" class="person-photo rounded" title="Imagem de fundo" @click="$refs.professionalProfileBackgroundImageInput.$el.childNodes[0].click()"></div>
                              <b-button class="delete-photo" size="sm" variant="danger" v-if="((personForm.id == null && canAdd) || (personForm.id != null && canEdit)) && (currentProfessionalProfileBackgroundImage || professionalProfileBackgroundImageFile || personForm.professional_profile.background_image)" @click="removeProfessionalProfileBackgroundImagePhoto"><i class="far fa-trash-alt"></i></b-button>
                              <label class="cj-label d-block">Selecionar imagem<br>de fundo</label>
                              <b-form-file class="d-block" style="width: 1px; height: 1px;opacity: 0" v-model="professionalProfileBackgroundImageFile" accept=".jpg, .png" placeholder="" ref="professionalProfileBackgroundImageInput" @input="professionalProfileBackgroundImageChanged" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))"></b-form-file>
                            </div>
                            <b-col>
                              <label class="cj-label">Estilo da imagem de fundo</label>
                              <multiselect v-model="personForm.professional_profile.background_image_style" :options="backgroundImageStyles" track-by="name" label="name" :showLabels="false" :searchable="false" placeholder="Selecione um tipo de campo" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))"></multiselect>
                            </b-col>
                            <b-col>
                              <label class="cj-label">Cor de fundo</label>
                              <b-form-input type="color" v-model="personForm.professional_profile.background_color" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))"></b-form-input>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row class="mb-3">
                        <b-col>
                          <hr>
                          <b-row>
                            <b-col cols="8">
                              <multiselect v-model="fieldType" :options="fieldTypes" track-by="name" label="name" :showLabels="false" :searchable="false" placeholder="Selecione um tipo de campo" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))"></multiselect>
                            </b-col>
                            <b-col>
                              <b-button variant="primary" block class="mr-3" @click="openFieldModal" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))">Adicionar</b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col class="mb-2">

                          <draggable v-model="personForm.professional_profile.items" group="people" @start="drag=true" @end="drag=false" @change="profileFieldsChanged" tag="b-list-group">
                            <b-list-group-item v-for="(field, index) in personForm.professional_profile.items" :key="field.id" class="d-flex justify-content-between align-items-center">
                              {{ (field.name !== null && field.name !== '') ? (field.name + ' - ') : '' }}{{ field.content }}
                              <b-button @click="editField(index)"><i class="far fa-edit"></i></b-button>
                            </b-list-group-item>
                          </draggable>
                        </b-col>
                      </b-row>

                    </b-col>
                    <b-col cols="12" md="4">
                      <b-row class="mb-3">
                        <b-col cols="6" offset="3" md="12" offset-md="0">
                          <label class="cj-label">Prévia</label>
                          <div id="professionalProfilePreview" :style='"background-color:" + personForm.professional_profile.background_color + ";" + personForm.professional_profile.background_image_style.css'>
                            <div class="p-3 d-flex flex-column align-items-center">
                              <div id="professionalProfilePhotoPreview" class="mb-3"></div>
                              <div class="professional-name mb-1" :style='"color:" + personForm.professional_profile.primary_color'>{{personForm.name}}</div>
                              <div class="mb-1" :style='"color:" + personForm.professional_profile.secondary_color'>{{getFormattedProfessionalRegistration()}}</div>
                              <div class="mb-4" :style='"color:" + personForm.professional_profile.secondary_color'>{{getFormattedSpecialties()}}</div>

                              <div v-for="(field, index) in personForm.professional_profile.items" :key="field.id + '_' + index" class="custom-field mb-2 d-flex justify-content-between align-items-center" :class="field.name !== '' ? 'text-left' : ''">
                                <div>
                                  <div v-if="field.name !== ''" class="mb-1" :style='"color:" + personForm.professional_profile.secondary_color'>{{field.name}}</div>
                                  <div class="custom-field-content" :style='"color:" + personForm.professional_profile.primary_color'>{{field.content}}</div>
                                </div>
                                <div class="icon" v-if="field.show_icon && getProfileFieldIcon(field.type) !== ''" :style='"color:" + personForm.professional_profile.primary_color'>
                                  <i :class="getProfileFieldIcon(field.type) + ' mr-2'"></i>
                                </div>
                              </div>
                            </div>
                            <div class="professional-card-footer p-2 mt-3" :style='"color:" + personForm.professional_profile.primary_color + ";border-color:" + personForm.professional_profile.secondary_color'>powered by Consultaja.com</div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="(personForm.id == null && canAdd) || (personForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="saveProfessionalProfile" :disabled="!canPerformAction">Salvar</b-button>
                </div>
              </div>
            </b-col>
          </b-row>

        </validation-observer>
      </div>
    </b-container>

    <b-modal id="field-modal" class="field-modal" size="lg" :modalClass="'field-modal'" @hidden="resetFieldModal">
      <template slot="modal-header">
        Adicionar novo campo
      </template>
      <template slot="default">
        <validation-observer ref="fieldForm" v-slot="{ invalid }">
          <b-container>
            <b-row class="mb-2">
              <b-col>
                <label class="cj-label">Tipo do campo</label>
                <validation-provider name="tipo de campo" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="fieldForm.type" :options="fieldTypes" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione um tipo de campo" :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value != 'text'">
                <label class="cj-label">Mostrar ícone</label>
                <validation-provider name="mostrar ícone" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="fieldForm.show_icon" :options="showIconOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione uma agenda" :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col>
                <label class="cj-label">Nome do campo</label>
                <b-form-input type="text" v-model="fieldForm.name"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col v-if="fieldForm.type.value == 'agenda'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <multiselect v-model="fieldForm.url" :options="agendas" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione uma agenda" :class="{ 'error': errors.length > 0 }"></multiselect>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'agenda'">
                <label class="cj-label">Texto da Agenda Online</label>
                <b-form-input type="text" v-model="fieldForm.content" autocomplete="off"></b-form-input>
              </b-col>

              <b-col v-if="fieldForm.type.value == 'email'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true, email: true }" v-slot="{ errors }">
                  <b-form-input type="email" v-model="fieldForm.content" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'address'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="text" v-model="fieldForm.content" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'instagram'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true, instagramUsername: true }" v-slot="{ errors }">
                  <b-input-group prepend="@">
                    <b-form-input type="text" v-model="fieldForm.content" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  </b-input-group>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>

              <b-col v-if="fieldForm.type.value == 'link'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="url" v-model="fieldForm.url" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'link'">
                <label class="cj-label">Texto do link</label>
                <b-form-input type="text" v-model="fieldForm.content" autocomplete="off"></b-form-input>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'phone'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="tel" v-model="fieldForm.content" v-mask="'(##) #####-####'" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'whatsapp'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-input type="tel" v-model="fieldForm.content" v-mask="'(##) #####-####'" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
              <b-col v-if="fieldForm.type.value == 'text'">
                <label class="cj-label">{{ fieldForm.type.name }}</label>
                <validation-provider :name="fieldForm.type.name.toLowerCase()" :rules="{ required: true }" v-slot="{ errors }">
                  <b-form-textarea v-model="fieldForm.content" rows="3" :class="{ 'error': errors.length > 0 }"></b-form-textarea>
                  <span class="cj-error">{{ errors[0] }}</span>
                </validation-provider>
              </b-col>
            </b-row>


          </b-container>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('field-modal')">Fechar</b-button>

        <b-button-group size="sm">
          <b-button variant="danger" v-if="fieldForm.id != null" @click="removeField(fieldForm.id)">Remover</b-button>
          <b-button variant="success" @click="addField">{{ (fieldForm.id == null?'Adicionar':'Editar') }}</b-button>
        </b-button-group>
      </template>
    </b-modal>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        user: null,
        digitalCardUrl: process.env.VUE_APP_DIGITAL_CARD_URL,
        aolUrl: process.env.VUE_APP_AOL_URL,

        termSingular: '',
        termPlural: '',
        url: '',
        letter: '',
        newTerm: '',
        module: '',

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        currentPhoto: null,
        photoFile: null,

        currentProfessionalProfileBackgroundImage: null,
        professionalProfileBackgroundImageFile: null,

        fieldType: null,
        fieldTypes: [
          { value: 'agenda', name: 'Agenda Online', icon: 'far fa-calendar-alt' },
          { value: 'email', name: 'E-mail', icon: 'far fa-envelope' },
          { value: 'address', name: 'Endereço', icon: 'far fa-map-marker-alt' },
          { value: 'instagram', name: 'Instagram', icon: 'fab fa-instagram' },
          { value: 'link', name: 'Link', icon: 'far fa-link' },
          { value: 'phone', name: 'Telefone', icon: 'far fa-phone fa-flip-horizontal' },
          { value: 'text', name: 'Texto livre', icon: '' },
          { value: 'whatsapp', name: 'Whatsapp', icon: 'fab fa-whatsapp' }
        ],
        backgroundImageStyles: [
          { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' },
          { value: 'contain', name: 'Conter', css: 'background-size:contain;' },
          { value: 'repeat', name: 'Repetir', css: 'background-repeat:repeat;' },
        ],

        agendas: [],

        fieldForm: {
          id: null,
          type: null,
          order: 0,
          name: '',
          content: '',
          url: '',
          show_icon: { value: true, name: 'Sim' }
        },

        showIconOptions: [
          { value: true, name: 'Sim' },
          { value: false, name: 'Não' }
        ],

        personForm: {
          id: null,
          photo: null,
          delete_photo: false,
          name: '',
          specialities: [],
          professional_registration: {
            id: null,
            council: null,
            state: null,
            number: null
          },
          professional_profile: {
            id: null,
            slug: null,
            primary_color: '#333333',
            secondary_color: '#999999',
            background_color: '#eeeeee',
            background_image: null,
            delete_background_image: false,
            background_image_style: { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' },
            enabled: false,
            items: []
          }
        }
      }
    },
    async mounted () {
      // if(this.$route.meta.type == 'PROFESSIONAL') {
      this.termSingular = 'profissional';
      this.termPlural = 'profissionais';
      this.url = 'profissionais';
      this.letter = 'o';
      this.newTerm = 'cadastrar-profissional';
      this.module = 'professionals';
      // }

      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canManage = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_manage');

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      this.user = JSON.parse(localStorage.getItem('user'));

      await this.api.getPerson(this.$route.params.id, {is_professional_profile: 1}).then(res => {
        this.canPerformAction = true;
        if(this.leavingPage) {
          return;
        }

        let personData = res.data;

        let professionalRegistration = (personData.professional_registration == null) ? {
          id: null,
          council: null,
          state: null,
          number: null
        } : personData.professional_registration;
        let professionalProfile = (personData.professional_profile == null) ? {
          id: null,
          slug: null,
          primary_color: '#333333',
          secondary_color: '#999999',
          background_color: '#eeeeee',
          background_image: null,
          delete_background_image: false,
          background_image_style: { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' },
          enabled: false,
          items: []
        } : personData.professional_profile;
        if(personData.professional_profile != null) {
          professionalProfile.background_image_style = this.backgroundImageStyles.find(style => style.value === professionalProfile.background_image_style);
          if(professionalProfile.background_image_style === undefined) {
            professionalProfile.background_image_style = { value: 'cover', name: 'Cobrir', css: 'background-size:cover;' };
          }
        }

        this.personForm = {
          id: personData.id,
          name: personData.name,
          specialities: [],
          professional_registration: professionalRegistration,
          professional_profile: professionalProfile
        };
        this.currentPhoto = personData.photo;
        this.updatePhoto();

        if(typeof personData.specialities != 'undefined') {
          personData.specialities.forEach(speciality => {
            this.personForm.specialities.push({value: speciality.id, name: speciality.name});
          });
        }

        if(this.personForm.professional_profile.slug === null || this.personForm.professional_profile.slug === '') {
          this.personForm.professional_profile.slug = this.slugify(this.personForm.name);
        }
        this.currentProfessionalProfileBackgroundImage = professionalProfile.background_image;
        this.updateProfessionalProfileBackgroundImage();

        if(typeof personData.agendas != 'undefined') {
          personData.agendas.forEach(agenda => {
            if(agenda.online_scheduling) {
              this.agendas.push({value: this.aolUrl + agenda.id, name: agenda.name});
            }
          });
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Person', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.goBack();

        this.$swal('Ops...', 'Não conseguimos carregar este ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Person', err.response);
      });
      this.eventBus.$emit('IS_LOADING', false);
    },
    methods: {
      async saveProfessionalProfile() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.personForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        if(this.canManage) {
          let professionalProfileData = {
            id: this.personForm.id,
            photo: this.personForm.photo,
            delete_photo: this.personForm.delete_photo,
            professional_profile: {
              id: this.personForm.professional_profile.id,
              slug: this.personForm.professional_profile.slug,
              primary_color: this.personForm.professional_profile.primary_color,
              secondary_color: this.personForm.professional_profile.secondary_color,
              background_color: this.personForm.professional_profile.background_color,
              background_image: this.personForm.professional_profile.background_image,
              delete_background_image: this.personForm.professional_profile.delete_background_image,
              background_image_style: this.personForm.professional_profile.background_image_style.value,
              enabled: this.personForm.professional_profile.enabled,
              items: this.personForm.professional_profile.items
            }
          };

          this.eventBus.$emit('IS_LOADING', true);
          if (this.personForm.professional_profile.id == null) {
            this.api.storeProfessionalProfile(this.personForm.id, professionalProfileData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 201) {
                this.$swal('Uhull \\o/', 'O cartão digital foi cadastrado com sucesso!', 'success').then(() => {
                  this.$router.go();
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao cadastrar o cartão digital! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Store Person', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let response = err.response;
              let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos cadastrar o cartão digital! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              this.$swal('Ops...', message, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Store Person', err.response);
            });
          } else {
            this.api.updateProfessionalProfile(this.personForm.id, this.personForm.professional_profile.id, professionalProfileData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 200) {
                this.$swal('Uhull \\o/', 'O cartão digital foi atualizado com sucesso!', 'success').then(() => {
                  this.$router.go();
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao atualizar o cartão digital! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Update Person', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let response = err.response;
              let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos cadastrar o cartão digital! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              this.$swal('Ops...', message, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Update Person', err.response);
            });
          }
        }
      },

      photoChanged() {
        this.personForm.photo = null;
        if (this.photoFile) {
          const scope = this;
          const reader = new FileReader();
          reader.onload = (event) => {
            scope.personForm.photo = event.target.result;
            scope.updatePhoto();
          };
          reader.readAsDataURL(this.photoFile);
        }
        else {
          this.updatePhoto();
        }
      },

      professionalProfileBackgroundImageChanged() {
        this.personForm.professional_profile.background_image = null;
        if (this.professionalProfileBackgroundImageFile) {
          const scope = this;
          const reader = new FileReader();
          reader.onload = (event) => {
            scope.personForm.professional_profile.background_image = event.target.result;
            scope.updateProfessionalProfileBackgroundImage();
          };
          reader.readAsDataURL(this.professionalProfileBackgroundImageFile);
        }
        else {
          this.updateProfessionalProfileBackgroundImage();
        }
      },

      removePhoto() {
        this.$swal({
          title: 'Você tem certeza?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Remover foto',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.personForm.photo = null;
            this.currentPhoto = null;
            this.photoFile = null;
            this.personForm.delete_photo = true;
            this.updatePhoto();
          }
        });
      },

      removeProfessionalProfileBackgroundImagePhoto() {
        this.$swal({
          title: 'Você tem certeza?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Remover foto',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.personForm.professional_profile.background_image = null;
            this.currentProfessionalProfileBackgroundImage = null;
            this.professionalProfileBackgroundImageFile = null;
            this.personForm.professional_profile.delete_background_image = true;
            this.updateProfessionalProfileBackgroundImage();
          }
        });
      },

      updatePhoto() {
        let photo = '', hasPhoto = true;
        if(this.personForm.photo != null) {
          photo = this.personForm.photo;
        } else if(this.currentPhoto != null) {
          photo = this.currentPhoto;
        } else {
          hasPhoto = false;
          photo = 'https://via.placeholder.com/70x70/eaf1f4/11a6f3';
        }
        if(document.getElementById('personPhoto')) {
          document.getElementById('personPhoto').style.backgroundImage = 'url("' + photo + '")';
        }
        if(document.getElementById('personPhotoPreview')) {
          document.getElementById('personPhotoPreview').style.backgroundImage = 'url("' + photo + '")';
        }
        if(document.getElementById('professionalProfilePhotoPreview')) {
          photo = hasPhoto ? photo : require('@/assets/images/digital-card-avatar.jpg');
          document.getElementById('professionalProfilePhotoPreview').style.backgroundImage = 'url("' + photo + '")';
        }
      },

      updateProfessionalProfileBackgroundImage() {
        let photo = '';
        if(this.personForm.professional_profile.background_image != null) {
          photo = this.personForm.professional_profile.background_image;
        } else if(this.currentProfessionalProfileBackgroundImage != null) {
          photo = this.currentProfessionalProfileBackgroundImage;
        } else {
          photo = '';
        }
        if(document.getElementById('professionalProfileBackgroundImage')) {
          document.getElementById('professionalProfileBackgroundImage').style.backgroundImage = 'url("' + photo + '")';
        }
        if(document.getElementById('professionalProfilePreview')) {
          document.getElementById('professionalProfilePreview').style.backgroundImage = 'url("' + photo + '")';
        }
      },

      isNullOrEmpty(value) {
        return value == null || value == '';
      },

      goBack() {
        this.$router.push({path: '/profissionais/' + this.$route.params.id}).catch(() => {});
      },

      getFormattedProfessionalRegistration() {
        if(this.personForm.professional_registration == null || this.personForm.professional_registration.number == null) {
          return '';
        }
        let registration = [];
        if(this.personForm.professional_registration.council != null) {
          registration.push(this.personForm.professional_registration.council);
        }
        if(this.personForm.professional_registration.state != null) {
          registration.push(this.personForm.professional_registration.state);
        }
        registration.push(this.personForm.professional_registration.number);
        return registration.join(' ');
      },

      getFormattedSpecialties() {
        let specialties = [];
        this.personForm.specialities.forEach(specialty => {
          specialties.push(specialty.name);
        });
        return specialties.join(' | ');
      },

      getProfileFieldIcon(fieldType) {
        return this.fieldTypes.find(type => type.value === fieldType).icon;
      },

      slugify(text) {
        return text
            .toString()                     // Cast to string
            .toLowerCase()                  // Convert the string to lowercase letters
            .normalize('NFD')       // The normalize() method returns the Unicode Normalization Form of a given string.
            .trim()                         // Remove whitespace from both sides of a string
            .replace(/\s+/g, '-')           // Replace spaces with -
            .replace(/[^\w-]+/g, '')       // Remove all non-word chars
            .replace(/--+/g, '-');        // Replace multiple - with single -
      },

      profileFieldsChanged() {
        for(let index = 0; index < this.personForm.professional_profile.items.length; index++) {
          this.personForm.professional_profile.items[index].order = index;
        }
      },

      async openFieldModal() {
        if(!this.canPerformAction || this.fieldType == null)
          return false;

        this.canPerformAction = false;

        let currentOrder = this.personForm.professional_profile.items.length;
        if(currentOrder === 20) {
          this.canPerformAction = true;
          this.$swal('Desculpe', 'Não é possível adicionar mais campos!', 'error');
          return false;
        }
        if (this.fieldType.value != 'link' && this.fieldType.value != 'text') {
          this.fieldForm.name = this.fieldType.name;
        }

        this.canPerformAction = true;
        this.fieldForm.type = this.fieldType;
        this.fieldForm.order = currentOrder;
        this.$bvModal.show('field-modal');
      },
      resetFieldModal() {
        this.fieldForm = {
          id: null,
          type: null,
          order: 0,
          name: '',
          content: '',
          url: '',
          show_icon: { value: true, name: 'Sim' }
        };
      },
      async addField() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.fieldForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let url = this.fieldForm.url;
        if(this.fieldForm.type.value == 'agenda') {
          url = url.value;
        }

        let fieldData = {
          id: this.fieldForm.id,
          type: this.fieldForm.type.value,
          name: this.fieldForm.name,
          content: this.fieldForm.content,
          url: url,
          order: this.fieldForm.order,
          show_icon: this.fieldForm.show_icon.value
        };

        if(fieldData.id == null) {
          fieldData.id = this.helpers.uuidv4();

          this.personForm.professional_profile.items.push(fieldData);
        } else {
          this.personForm.professional_profile.items = this.personForm.professional_profile.items.map(field => {
            if(field.id == fieldData.id)
              field = fieldData;

            return field;
          });
        }

        this.personForm.professional_profile.items.sort((a, b) => (a.order > b.order)?1:-1);

        this.$bvModal.hide('field-modal');
        this.canPerformAction = true;
      },
      async editField(index) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        let field = this.personForm.professional_profile.items[index];

        this.fieldForm = {
          id: field.id,
          type: this.fieldTypes.find(type => type.value === field.type),
          order: field.order,
          name: field.name,
          content: field.content,
          url: field.url,
          show_icon: this.showIconOptions.find(showIcon => showIcon.value === field.show_icon),
        };
        if(field.type == 'agenda') {
          this.fieldForm.url = this.agendas.find(agenda => agenda.value === field.url);
        }

        this.$bvModal.show('field-modal');
        this.canPerformAction = true;
      },
      async removeField(fieldId) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        this.personForm.professional_profile.items = this.personForm.professional_profile.items.filter(field => {
          return field.id != fieldId
        });

        this.$bvModal.hide('field-modal');
        this.canPerformAction = true;
      },
    },

    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .person-form {
    padding: 20px 0;

    .photo-container {
      position: relative;
      text-align: center;

      .person-photo {
        cursor: pointer;
        margin-left: 15px;
        margin-right: 15px;
        width: 70px;
        height: 70px;
        background: #f0f0f0 no-repeat 50%;
        background-size: contain;
        border: 1px solid $linkWater;

        &#personPhotoPreview {
          cursor: default;
        }
      }

      .delete-photo {
        position: absolute;
        top: 0;
        right: 15px;
        padding: 0.25rem 0.45rem;
        font-size: 0.8rem;
      }
    }
  }

  .text1 {
    font-size: 15px;
    color: $cadetGray;
    margin-bottom: 0;
  }
  .input-group-prepend {
    height: 35px;

    .input-group-text {
      font-size: 15px;
    }
  }

  .input-group-append {
    height: 35px;
  }

  #professionalProfilePreview {
    background-position: center;
    background-repeat: no-repeat;
    text-align: center;
    font-size: 13px;

    #professionalProfilePhotoPreview {
      width: 100px;
      height: 100px;
      background: #f0f0f0 no-repeat 50%;
      background-size: cover;
    }

    .professional-name {
      font-size: 14px;
    }

    .custom-field {
      background: #fffffff2;
      border-radius: 14px;
      padding: 14px;
      width: 100%;

      .custom-field-content {
        font-size: 14px;
      }

      .icon {
        font-size: 15px;
      }
    }

    .professional-card-footer {
      border-top: 1px solid #ccc;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
